export default __webpack_public_path__ + "static/media/draft.923c74fa.svg";